import React, { FunctionComponent, useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { AddButton, CardList, SubmitButton } from 'components';
import { FormGroup } from 'components/chroma';
import { PolicyHolder, YesNoAnswer } from 'scenes/common/types';
import { getAdditionalPolicyHolders } from 'scenes/home/selectors';
import { HomeFullPageProps } from 'scenes/home/types';

import { AdditionalPolicyHolderCard } from './AdditionalPolicyHolderCard';

export const AdditionalPolicyHolderListStep: FunctionComponent<Pick<
  HomeFullPageProps,
  'funnelState' | 'onRemoveAdditionalPolicyHolder' | 'onNext'
>> = ({ funnelState, onRemoveAdditionalPolicyHolder, onNext }) => {
  const {
    formState: { isValid },
    handleSubmit,
  } = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
  });

  const additionalPolicyHolders: PolicyHolder[] = getAdditionalPolicyHolders(
    funnelState
  );

  const onSubmit = useCallback(() => {
    onNext({ addAdditionalPolicyHolder: YesNoAnswer.No });
  }, [onNext]);

  const handleAddAdditionalItem = useCallback(() => {
    onNext({ addAdditionalPolicyHolder: YesNoAnswer.Yes });
  }, [onNext]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup
        label={
          additionalPolicyHolders.length > 0
            ? 'Additional policy holders'
            : 'No additional policy holders'
        }
      >
        <CardList marginBottom="1rem" role="list">
          {additionalPolicyHolders.map((additionalPolicyHolder, index) => (
            <AdditionalPolicyHolderCard
              key={`${additionalPolicyHolder.firstName}${additionalPolicyHolder.lastName}`}
              policyHolder={additionalPolicyHolder}
              policyHolderIndex={index}
              onClickEdit={onNext}
              onClickRemove={onRemoveAdditionalPolicyHolder}
            />
          ))}
        </CardList>
        <AddButton onClick={handleAddAdditionalItem}>
          Add another policy holder
        </AddButton>
      </FormGroup>
      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default AdditionalPolicyHolderListStep;
